export const MIN_SEARCH_QUERY_LENGTH = 1;
export const SEARCH_INPUT_SEND_ANALYTICS_DELAY = 1000;
export const SEARCH_SIZE_PARAMS: { size: number } = { size: 10 };
